import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import alerts from '@/locales/fr/alerts.json';
import auth from '@/locales/fr/auth.json';
import common from '@/locales/fr/common.json';
import dashboards from '@/locales/fr/dashboards.json';
import home from '@/locales/fr/home.json';
import notifications from '@/locales/fr/notifications.json';
import palette from '@/locales/fr/palette.json';
import rules from '@/locales/fr/rules.json';
import settings from '@/locales/fr/settings.json';
import sources from '@/locales/fr/sources.json';
import widgets from '@/locales/fr/widgets.json';

/**
 * All user-facing strings live in src/locales/fr, namespaced by feature
 * (TechSpec §8.4). Resources are bundled — there is one language and no
 * reason to fetch it. Keys are type-checked through CustomTypeOptions.
 */
export const resources = {
  fr: {
    common,
    auth,
    home,
    settings,
    dashboards,
    sources,
    rules,
    alerts,
    notifications,
    widgets,
    palette,
  },
} as const;

export const defaultNS = 'common';

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: typeof defaultNS;
    resources: (typeof resources)['fr'];
  }
}

void i18n.use(initReactI18next).init({
  lng: 'fr',
  fallbackLng: 'fr',
  resources,
  defaultNS,
  ns: [
    'common',
    'auth',
    'home',
    'settings',
    'dashboards',
    'sources',
    'rules',
    'alerts',
    'notifications',
    'widgets',
    'palette',
  ],
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
